import { render, staticRenderFns } from "./FormulateBadgePicker.vue?vue&type=template&id=d4f07b28&scoped=true"
import script from "./FormulateBadgePicker.vue?vue&type=script&lang=js"
export * from "./FormulateBadgePicker.vue?vue&type=script&lang=js"
import style0 from "./FormulateBadgePicker.vue?vue&type=style&index=0&id=d4f07b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f07b28",
  null
  
)

export default component.exports